'use strict';

import axios from '@/utils/axios';

// 已上架资源列表
export const resourcelist = async (params) => {
    return await axios.get(`/api/ops/portal/resource/list/on_shelf`, { params: params });
};

// 资源详情
export const resourcedtl = async (params) => {
    return await axios.get(`/api/ops/portal/resource/${params.id}`, { params: params });
};
